import { makeStyles, tokens, shorthands } from '@fluentui/react-components';
import { mq } from '../../../theme/scalingTokens';

export const useSpaceCardSkeletonStyles = makeStyles({
  root: {
    ...shorthands.border('1px', 'solid', tokens.colorNeutralStroke1),
    ...shorthands.borderRadius('0.5rem'),
    backgroundColor: tokens.colorNeutralBackground1,
    ...shorthands.overflow('hidden'),
  },

  topRow: {
    display: 'flex',
    ...shorthands.padding(
      tokens.spacingVerticalM,
      tokens.spacingHorizontalM,
      tokens.spacingVerticalM,
      tokens.spacingHorizontalM
    ),
    gap: tokens.spacingHorizontalL,
    [mq.tablet]: {
      flexDirection: 'column',
    },
  },

  imageArea: {
    maxWidth: '14.3125rem',
    flexBasis: '30%',
    flexShrink: 0,
    minHeight: '12.0625rem',
    ...shorthands.borderRadius('1rem'),
    [mq.tablet]: {
      maxWidth: '100%',
      flexBasis: 'auto',
      width: '100%',
      height: '10rem',
      minHeight: 'unset',
    },
  },

  contentSection: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    ...shorthands.padding(
      tokens.spacingVerticalS,
      tokens.spacingHorizontalXS,
      tokens.spacingVerticalM,
      tokens.spacingHorizontalXS
    ),
    rowGap: tokens.spacingVerticalM,
    minWidth: 0,
  },

  title: {
    width: '60%',
    height: '1.125rem',
  },

  metadata: {
    width: '30%',
    height: '0.875rem',
  },

  amenityRow: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: tokens.spacingHorizontalS,
    rowGap: tokens.spacingVerticalXS,
    marginTop: tokens.spacingVerticalM,
  },

  amenityChip: {
    width: '4rem',
    height: '1.5rem',
    ...shorthands.borderRadius(tokens.borderRadiusCircular),
  },
});
